import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const TiersLedger = lazy(() => import('./TiersLedger'))

export const BalanceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--balance']}>
    <Route index element={<Index />} />
    <Route path='tiers/:entityId' element={<TiersLedger />} />
  </SubRouter>
))
